import type { IWalletEventStrategy } from "./interfaces"

/**
 * Default wallet event strategy that always starts/stops queries
 * on wallet connect/disconnect. Used by the normal lock orchestrator.
 */
export class WalletEventStrategy implements IWalletEventStrategy {
  shouldStartQueriesOnWalletConnect(): boolean {
    return true
  }

  shouldStopQueriesOnWalletDisconnect(): boolean {
    return true
  }
}

